// extracted by mini-css-extract-plugin
export default {"page":"NotImplemented_page__i9FxI"};